import { render, staticRenderFns } from "./MessageFiltering.vue?vue&type=template&id=9be530ee&scoped=true&"
import script from "./MessageFiltering.vue?vue&type=script&lang=js&"
export * from "./MessageFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be530ee",
  null
  
)

export default component.exports